/**
 * Title row for the RMA list filters sidebar (funnel icon + "Filters" label).
 */
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import IconFunnel from "../../../../../../../components/icons/icon-funnel/icon-funnel";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

const RmaListFiltersSidebarTitle: React.FC = () => {
    const { getTranslation } = useDashboardTranslation();

    return (
        <div className="rma-list-filters-sidebar__title-row">
            <IconFunnel color="var(--color-neutral-3)" />
            <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                {getTranslation("FILTERS_TITLE", "dashboard-returns-page")}
            </FontBody1>
        </div>
    );
};

export default RmaListFiltersSidebarTitle;
